import { QuestionType } from '../typings';

export const generateLoginFieldBaseFieldId = (
  accountQuestionType: QuestionType,
): string => {
  switch (accountQuestionType) {
    case QuestionType.Unknown:
      return 'unknown';
    case QuestionType.FirstName:
      return 'firstName';
    case QuestionType.LastName:
      return 'lastName';
    case QuestionType.NPI:
      return 'npi';
    case QuestionType.SSNLast4Digits:
      return 'ssnLast4Digits';
    case QuestionType.DOB:
      return 'dob';
  }
};
